import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Resource} from 'app/constants/resource';
import EntityCrudService from 'app/blocks/service/api/entity-service';
import {IVatType, VatType} from 'app/blocks/model/vat-type-model';
import {SERVER_API_URL} from 'app/app.constants';
import {Observable} from 'rxjs';
import moment from 'moment';

@Injectable({
    providedIn: 'root'
})
export class VatTypeService extends EntityCrudService<IVatType> {
    constructor(http: HttpClient) {
        super(http, Resource.VAT_TYPE, (obj?) => new VatType(obj));
    }

    /** The VAT rate in force on `date` (today when omitted). Sent as a plain day so no timezone can shift it. */
    findActive(vatTypeId, date?: Date | string): Promise<any> {
        const params = date ? {date: moment(date).format('YYYY-MM-DD')} : {};
        return this.http.get(SERVER_API_URL + 'api/vat-types/' + vatTypeId + '/active', {params}).toPromise();
    }
}
